import { GeneralService, HttpService } from './api';
import { GeneralStore } from './general.store';

/**
 * Root Store Class with
 */
class RootStore {
  private http = new HttpService(
    () => ({
      baseURL: 'https://rvskm04khb.execute-api.eu-west-1.amazonaws.com/dev'
    }),
    {}
  );

  public api = {
    general: new GeneralService(this.http)
  };
  general: GeneralStore;

  constructor() {
    this.general = new GeneralStore(this);
  }
}

const store = new RootStore();

export { RootStore, store };
